import { Injectable } from '@angular/core';
import { Observer, Subject, Subscription } from 'rxjs';
import { CommunicatorCommandsEnum, CommunicatorModel, CommunicatorSetModel, VisibilityChangeModel } from './model/communicatorModel';
import { Application, ControlPath, Qualifier } from '../model';
import { configDefault } from '../app-defaults';

@Injectable({
    providedIn: 'root'
})
export class CommunicatorService {
    private readonly _applicationChangeSbj = new Subject<CommunicatorModel>();
    private readonly visibilityChangeSbj = new Subject<VisibilityChangeModel>();
    private readonly messageSbj = new Subject<any>();
    // private readonly dictionary: object = {};

    private _applicationData: object = {};

    constructor() { }

    get applicationData() {
        return this._applicationData;
    }

    get applicationChangeObj$() {
        return this._applicationChangeSbj.asObservable();
    }

    get visibilityChanged$() {
        return this.visibilityChangeSbj.asObservable();
    }

    sendVisibilityChangeMessage(message: VisibilityChangeModel) {
        this.visibilityChangeSbj.next(message);
    }

    sendMessage(message: any) {
        this.messageSbj.next(message);
    }

    sendApplicationChangeMessage(message: CommunicatorModel, delayMilliseconds?: number | null) {
        this._applicationChangeSbj.next(message);

        // let self = this;
        // let keyVal = (<any>this.dictionary)[message.fullpath];

        // if (keyVal) {
        //     clearTimeout(keyVal)
        // }

        // let delay = delayMilliseconds == 0 ? 0 : (delayMilliseconds | configDefault.timings.applicationChangeDelay);

        // (<any>this.dictionary)[message.fullpath] = setTimeout(function () {
        //     self._applicationChangeSbj.next(message);
        //     (<any>self.dictionary)[message.fullpath] = undefined;
        // }, delay);
    }

    subscribeToMessaging(observerOrNext?: Partial<Observer<any>> | ((value: any) => void)): Subscription {
        return this.messageSbj.subscribe(observerOrNext);
    }

    subscribeToVisibilityChange(observerOrNext?: Partial<Observer<VisibilityChangeModel>> | ((value: VisibilityChangeModel) => void)): Subscription {
        return this.visibilityChangeSbj.subscribe(observerOrNext);
    }

    setApplication(app: Application) {
        app = app || <any>{};
        let data = app?.data || {};
        data.$$qualifier = data.$$qualifier || new Qualifier();

        this._applicationData = this._wrapObject(data);
        this.sendApplicationChangeMessage(new CommunicatorModel(CommunicatorCommandsEnum.proxyObjectChanged, null, null, null, data));
    }

    getApplicationData() {
        return this.applicationData;
    }

    private _wrapObject(objForProxy: any) {
        let self = this;

        const handler: ProxyHandler<any> = <ProxyHandler<any>>{
            get: (obj: any, prop: string | symbol): any => {
                if (prop == '$$qualifier') {
                    return Reflect.get(obj, prop);
                }

                if (typeof obj[prop] !== 'object' ||
                    obj[prop] == null ||
                    prop == '__proxyObj') {
                    return Reflect.get(obj, prop);
                }

                if (!obj[prop].__proxyObj) {
                    Object.defineProperty(
                        obj[prop],
                        "__proxyObj", {
                        value: {},
                        configurable: false,
                        enumerable: false,
                    });
                }

                let parentQualifier: Qualifier = null;
                let path = obj?.__proxyObj?.path;
                if (path instanceof Qualifier) {
                    parentQualifier = path.clone();
                } else if (!path) {
                    parentQualifier = new Qualifier();
                } else {
                    parentQualifier = new Qualifier(obj?.__proxyObj?.path.toString());
                }

                if (obj instanceof Array) {
                    let last = parentQualifier.pop();
                    last.index = parseInt(<string>prop, 10);
                    parentQualifier.push(last);

                    obj[prop].__proxyObj.path = parentQualifier;
                } else {
                    parentQualifier.push(new ControlPath(<string>prop));
                    obj[prop].__proxyObj.path = parentQualifier;
                }

                return new Proxy(obj[prop], handler);
            },
            set: function (obj: any, prop: string | symbol, value: any) {
                let oldVal = obj[prop],
                    objSet = value,
                    delay = null,
                    isCalculationUpdate = false;
                if (value instanceof CommunicatorSetModel) {
                    objSet = value.val;
                    delay = value.delay;
                    isCalculationUpdate = !!value.isCalculationUpdate;
                }

                let val = Reflect.set(obj, prop, objSet);

                self.sendApplicationChangeMessage(
                    new CommunicatorModel(
                        CommunicatorCommandsEnum.set,
                        <string>prop,
                        obj?.__proxyObj?.path,
                        oldVal,
                        objSet,
                        isCalculationUpdate),
                    delay);

                return val;
            },
            deleteProperty: function (obj: any, prop: string | symbol) {
                let val = Reflect.deleteProperty(obj, prop);
                self.sendApplicationChangeMessage(
                    new CommunicatorModel(
                        CommunicatorCommandsEnum.deleteProperty,
                        <string>prop,
                        obj?.__proxyObj?.path,
                        null,
                        null));
                return val;
            }
        };
        return new Proxy(objForProxy, handler);
    }
}
